import messagesFr from "../../translations/fr.json";

export const localeFr = {
    lang: 'fr',
    messages: messagesFr
}